<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { ref, withDefaults, defineProps } from 'vue';

const props = withDefaults(
  defineProps<{ innerText?: string; index?: number }>(),
  {
    innerText: '大标题'
  }
);

const translateY = ref(props.innerText.length * 24 - 80);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="40" viewBox="0 0 1024 30">
  <g id="xiaobiao8" transform="translate(0 -9)">
    <text id="项目执行人性别分布" transform="translate(31.502 32)" fill="#222" font-size="22" font-weight="600" letter-spacing="0.09em"><tspan x="0" y="0">${
      props.innerText
    }</tspan></text>
  
    <path id="路径_5240" data-name="路径 5240" d="M128,0h9l3,21h-9Z" transform="translate(-116 14)" fill="var(--theme-color-1)" fill-opacity="0.6"/>
    <path id="路径_5239" data-name="路径 5239" d="M128,0h9l3,21h-9Z" transform="translate(-128 14)" fill="var(--theme-color-1)"/>
    
    <path id="路径_5238" data-name="路径 5238" d="M140,0h-9l-3,21h9Z" transform="translate(${
      translateY.value
    } 14)" fill="var(--theme-color-1)"/>
    <path id="路径_5236" data-name="路径 5236" d="M140,0h-9l-3,21h9Z" transform="translate(${
      translateY.value - 12
    } 14)" fill="var(--theme-color-1)" fill-opacity="0.6"/>
  </g>
</svg>
`;
</script>
<style lang="scss" scoped></style>
